export default "__VITE_ASSET__C2VzBs5R__"